module.exports = __webpack_public_path__ + "img/consult_info1.1006673e.png";